module.exports = __webpack_public_path__ + "static/sustainable-lodging-87d88ea61274539d8ebd438fa2ee2653.jpg";